/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isProCodeComponentType(desc) {
  return 'package' in desc;
}